// eslint-disable-next-line no-undef
const stripe = Stripe(process.env.REACT_APP_STRIPE_KEY);

const createToken = (type, data) => stripe.createToken(type, data);

export const tokenizeBankAccount = data => createToken('bank_account', data);

export const tokenizePersonalId = id => createToken('pii', { personal_id_number: id });
